import { useState, useEffect, useRef, useMemo } from "react";
import { FiEyeOff } from "react-icons/fi";
import { FaUsers } from "react-icons/fa";
import { IoCloseCircleSharp } from "react-icons/io5";


import { MdOutlineArrowDropDown, MdSubject, MdOutlineContentCopy } from "react-icons/md";
import { BsPaperclip } from "react-icons/bs";
import { LiaGoogleDrive } from "react-icons/lia";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaRegTrashAlt } from "react-icons/fa";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { DataState } from "../../context/DataProvider";
import { replyToEmail } from "../../services/api";
import toast from "react-hot-toast";
import { draftEmail, sendEmail } from "../../services/email_api";
import { FaFilePdf, FaFileWord, FaFileExcel, FaFileImage, FaFileAudio, FaFileVideo, FaFileArchive, FaFile } from "react-icons/fa";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { FiDownload } from 'react-icons/fi';
import { HiPencilSquare } from "react-icons/hi2";
import useDrivePicker from "react-google-drive-picker";
import { google_client_id, google_api_key } from "../../utils/keys";
import UseEmails from "../../context/EmailsProvider";


const getFileIcon = (mimeType) => {
  if (mimeType?.includes("pdf")) return <FaFilePdf className="text-red-500" size={20} />;
  if (mimeType?.includes("word")) return <FaFileWord className="text-[#5652CF]" size={20} />;
  if (mimeType?.includes("excel")) return <FaFileExcel className="text-green-500" size={20} />;
  if (mimeType?.includes("image")) return <FaFileImage className="text-yellow-500" size={20} />;
  if (mimeType?.includes("zip") || mimeType?.includes("rar")) return <FaFileArchive className="text-gray-500" size={20} />;
  if (mimeType?.includes("audio")) return <FaFileAudio className="text-purple-500" size={20} />;
  if (mimeType?.includes("video")) return <FaFileVideo className="text-indigo-500" size={20} />;
  return <FaFile className="text-gray-500" size={20} />;
};

const AttachmentItem = ({ file, onRemove }) => {

  const [hovered, setHovered] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadClick = async () => {
    if (isDownloading) return;
    setIsDownloading(true);

    try {
      const url = URL.createObjectURL(file?.file);
      const a = document.createElement("a");
      a.href = url;
      a.download = file?.file.name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (

    <div
      className="text-gray-500 w-40 h-10 py-3 border p-2 rounded-lg shadow-md cursor-pointer inline-flex items-center justify-center"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >

      {hovered ? (
        <div className="flex gap-4 items-center justify-center w-full">
          {isDownloading ? (
            <AiOutlineLoading3Quarters className="text-gray-600 animate-spin" size={16} />
          ) : (
            <FiDownload
              onClick={handleDownloadClick}
              className="text-gray-600 cursor-pointer hover:text-black"
              size={16}
            />
          )}

          <button onClick={() => onRemove(file)} className="ml-2 text-gray-600 hover:text-red-400">&times;</button>

        </div>
      ) : (
        <div className="flex items-center space-x-2 w-full">
          <div className="w-8 h-8 flex items-center justify-center">
            {getFileIcon(file?.file.mimeType || file?.file.type)} {/* Handle both cases */}
          </div>
          <span className="truncate text-sm font-medium">
            {file?.file.filename || file?.file.name} {/* Handle both cases */}
          </span>
        </div>
      )}

    </div>

  );
};

const ComposeEmail = ({
  setIsComposeEmailModalOpen,
  message_id,
  isOutlook
}) => {
  const [messageBody, setMessageBody] = useState("");
  const [showCc, setShowCc] = useState(false);
  const [showBcc, setShowBcc] = useState(false);
  const { userInfo, userGoogleId } = DataState();
  const [loading, setLoading] = useState(false);
  const [recepientsEmails, setRecepientsEmails] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [inputCcValue, setInputCcValue] = useState("");
  const [inputBccValue, setInputBccValue] = useState("");
  const [customPromptLoading, setCustomPromptLoading] = useState(false);
  const [customPrompt, setCustomPrompt] = useState("");
  const fileInputRef = useRef(null);
  const [openPicker] = useDrivePicker();




  const [subject, setSubject] = useState("");
  const [ccs, setCcs] = useState([]);
  const [bccs, setBccs] = useState([]);

  const [driveAttachments, setDriveAttachments] = useState([]);
  const [localAttachments, setLocalAttachments] = useState([]);

  const attachments = useMemo(() => {
    return [
      ...localAttachments.map(file => ({ name: file.name, from: "local", file })),
      ...driveAttachments.map(file => ({ name: file.name, from: "drive", id: file.id, file })),
    ];
  }, [localAttachments, driveAttachments]);

  const handleTrashClick = () => {
    if (
      !recepientsEmails.length &&
      !ccs.length &&
      !bccs.length &&
      !subject &&
      !messageBody &&
      !customPrompt &&
      !localAttachments.length &&
      !driveAttachments.length
    ) {
      setIsComposeEmailModalOpen(false); // Close the modal if everything is already empty
      return;
    }

    // Reset all fields
    setRecepientsEmails([]);
    setCcs([]);
    setBccs([]);
    setSubject("");
    setMessageBody("");
    setCustomPrompt("")
    setLocalAttachments([]);
    setDriveAttachments([]);
    setInputValue("");
    setInputCcValue("");
    setInputBccValue("");

  };


  const validEmailProviders = [
    "gmail.com",
    "outlook.com",
    "yahoo.com",
    "hotmail.com",
    "icloud.com",
    "protonmail.com",
    "zoho.com",
    "aol.com",
    "gmx.com"
  ];


  useEffect(() => {
    console.log("messageBody: ", messageBody);
  }, [messageBody]);

  const modules = {
    toolbar: [
      [{ font: [] }, { size: [] }], // Font and Size
      ["bold", "italic", "underline", "strike"], // Formatting
      [{ color: [] }, { background: [] }], // Text color & Background color
      [{ list: "ordered" }, { list: "bullet" }], // Ordered & Unordered lists
      [{ align: [] }], // Alignment options
      ["blockquote"], // Blockquote & Code block
      ["link", "image"], // Links & Images
      ["clean"], // Remove formatting
    ],
  };

  const formats = [
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "list",
    "bullet",
    "align",
    "blockquote",
    "link",
    "image",
    "clean",
  ];

  // Add dark mode styles for ReactQuill
  useEffect(() => {
    // Add custom CSS for dark mode Quill editor
    const style = document.createElement('style');
    style.innerHTML = `
      .ql-snow .ql-stroke {
        stroke: #a1a1aa;
      }
      .ql-snow .ql-fill {
        fill: #a1a1aa;
      }
      .ql-snow .ql-picker {
        color: #a1a1aa;
      }
      .ql-snow .ql-picker-options {
        background-color: #27272a;
        border-color: #3f3f46;
      }
      .ql-snow.ql-toolbar button:hover, 
      .ql-snow .ql-toolbar button:hover, 
      .ql-snow.ql-toolbar button.ql-active, 
      .ql-snow .ql-toolbar button.ql-active, 
      .ql-snow.ql-toolbar .ql-picker-label:hover, 
      .ql-snow .ql-toolbar .ql-picker-label:hover, 
      .ql-snow.ql-toolbar .ql-picker-label.ql-active, 
      .ql-snow .ql-toolbar .ql-picker-label.ql-active, 
      .ql-snow.ql-toolbar .ql-picker-item:hover, 
      .ql-snow .ql-toolbar .ql-picker-item:hover, 
      .ql-snow.ql-toolbar .ql-picker-item.ql-selected, 
      .ql-snow .ql-toolbar .ql-picker-item.ql-selected {
        color: #d4d4d8;
      }
      .ql-snow.ql-toolbar button:hover .ql-stroke, 
      .ql-snow .ql-toolbar button:hover .ql-stroke, 
      .ql-snow.ql-toolbar button.ql-active .ql-stroke, 
      .ql-snow .ql-toolbar button.ql-active .ql-stroke, 
      .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke, 
      .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke, 
      .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke, 
      .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke, 
      .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke, 
      .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke, 
      .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke, 
      .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke {
        stroke: #d4d4d8;
      }
      .ql-snow.ql-toolbar, .ql-snow .ql-toolbar {
        border-color: #3f3f46;
        background-color: #27272a;
      }
      .ql-container.ql-snow {
        border-color: #3f3f46;
      }
      .ql-editor {
        color: #d4d4d8;
        background-color: #18181b;
      }
      .ql-editor.ql-blank::before {
        color: #71717a;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const removeEmail = (index) => {
    setRecepientsEmails(recepientsEmails.filter((_, i) => i !== index));
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    setLocalAttachments((prevAttachments) => [...prevAttachments, ...files]);
  };

  const handleRemove = (fileToRemove) => {
    if (fileToRemove.from === "local") {
      setLocalAttachments((prev) => prev.filter((file) => file.name !== fileToRemove.name));
    } else if (fileToRemove.from === "drive") {
      setDriveAttachments((prev) => prev.filter((file) => file.id !== fileToRemove.id));
    }
  };

  const handlePaperClipClick = () => {
    fileInputRef.current.click();
  };

  const handleKeyDown = (event) => {
    if (event.key === "," || event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      const email = inputValue.trim().replace(/,$/, "");

      // Email pattern: username@provider.domain
      const emailPattern = /^[a-zA-Z0-9._%+-]+@([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
      const match = email.match(emailPattern);

      if (email && !recepientsEmails.includes(email)) {
        if (match) {
          const domain = match[1];

          if (validEmailProviders.includes(domain)) {
            setRecepientsEmails([...recepientsEmails, email]);
            setInputValue("");
          } else {
            toast.error("Invalid email provider!");
          }
        } else {
          toast.error("Invalid email format!");
        }
      }
    }
  };
  const handleCcKeyDown = (event) => {
    if (event.key === "," || event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      const email = inputCcValue.trim().replace(/,$/, "");

      // Email pattern: username@provider.domain
      const emailPattern = /^[a-zA-Z0-9._%+-]+@([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
      const match = email.match(emailPattern);

      if (email && !ccs.includes(email)) {
        if (match) {
          const domain = match[1];

          if (validEmailProviders.includes(domain)) {
            setCcs([...ccs, email]);
            setInputCcValue("");
          } else {
            toast.error("Invalid email provider!");
          }
        } else {
          toast.error("Invalid email format!");
        }
      }
    }
  };
  const handleBccKeyDown = (event) => {
    if (event.key === "," || event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      const email = inputBccValue.trim().replace(/,$/, "");

      // Email pattern: username@provider.domain
      const emailPattern = /^[a-zA-Z0-9._%+-]+@([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
      const match = email.match(emailPattern);

      if (email && !bccs.includes(email)) {
        if (match) {
          const domain = match[1];

          if (validEmailProviders.includes(domain)) {
            setBccs([...bccs, email]);
            setInputBccValue("");
          } else {
            toast.error("Invalid email provider!");
          }
        } else {
          toast.error("Invalid email format!");
        }
      }
    }
  };
  const handleDraftEmail = async () => {
    setCustomPromptLoading(true);

    const requestBody = {
      custom_prompt: customPrompt || undefined,
      previous_email_body: messageBody || undefined,
      previous_subject: subject || undefined,
      recipients: recepientsEmails.length > 0 ? recepientsEmails : undefined,
    };
    try {

      const response = await draftEmail(userGoogleId, requestBody, isOutlook);

      setMessageBody(response?.html_body || "");
      setSubject(response?.subject || "");

      toast.success("Email Draft successfully!");
    } catch (error) {
      console.error("Email Draft Error:", error);
      toast.error("Failed to draft Email . Try again.");
    }
    finally { setCustomPromptLoading(false); }
  };

  const handleSendEmail = async () => {
    setLoading(true);

    if (!recepientsEmails.length || !subject || !messageBody) {
      toast.error("Please fill all required fields.");
      setLoading(false);
      return;
    }
    console.log("Message Body for Compose Email:", messageBody);

    const formData = new FormData();

    // Append each recipient separately
    recepientsEmails.forEach(email => formData.append("recipients", email));

    formData.append("subject", subject);
    formData.append("message_body", messageBody);
    formData.append("user_google_id", userGoogleId);

    // Conditionally append CCs if they exist and are non-empty
    if (ccs && ccs.length > 0) {
      ccs.forEach(email => formData.append("ccs", email));
    }

    // Conditionally append BCCs if they exist and are non-empty
    if (bccs && bccs.length > 0) {
      bccs.forEach(email => formData.append("bccs", email));
    }

    // Append attachments if present
    //local attachments
    if (localAttachments.length > 0) {
      localAttachments.forEach((file) => {
        formData.append("files", file);
      });
    }
    // drive attachments
    const driveFileIds = driveAttachments.map(file => file.id);
    driveFileIds.forEach(id => formData.append("google_drive_file_ids", id));

    try {
      await sendEmail(userGoogleId, formData, isOutlook);
      toast.success("Email sent successfully!");
      setMessageBody("");
      setLocalAttachments([]);
      setDriveAttachments([]);
      setRecepientsEmails([]);
      setCcs([]);
      setBccs([]);
      setCustomPrompt("");
      setSubject("");
      setInputValue("");
      setInputCcValue("");
      setInputBccValue("");
    } catch (error) {
      console.error("Send Email Error:", error);
      toast.error("Failed to send email.");
    } finally {
      setLoading(false);
    }
  };

  const handleOpenPicker = () => {
    openPicker({
      clientId: google_client_id,
      developerKey: google_api_key,
      viewId: "DOCS",
      showUploadView: true,
      showUploadFolders: true,
      supportDrives: true,
      multiselect: true,
      callbackFunction: (data) => {
        if (data.action === "picked") {
          console.log("datadocs", data.docs);
          const files = data.docs.map((file) => ({
            id: file.id,
            name: file.name,
            mimeType: file?.mimeType || file?.type,
            url: file.url,
          }));
          setDriveAttachments((prev) => [
            ...prev,
            ...files
          ]);
          console.log("Selected Files:", files);
        } else {
          console.log("Picker closed without selecting a file.");
        }
      },
    });
  };




  return (
    <div className="fixed w-full inset-0 z-50 flex items-center justify-center">
      {/* Blurry Background Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-30 backdrop-blur-sm"></div>
      <div className="absolute top-20 flex flex-row w-5/6 sm:w-2/3 max-h-[80vh] overflow-y-auto scrollbar-none">

        <div className="flex flex-col w-full">

          <div className="border border-zinc-700 rounded-xl p-4 shadow-md bg-zinc-800 w-full">
            <div className="flex text-zinc-300 sm:items-center justify-between gap-1 mb-6">
              <div className="flex sm:items-center gap-2 text-zinc-300 text-lg font-semibold">
                {isOutlook ? (
                  <img src="/assets/icons8-microsoft-outlook.svg" alt="Outlook" className="h-7 w-7" />
                ) : (
                  <img src="/assets/icons8-gmail.svg" alt="Gmail" className="h-7 w-7" />
                )}
                Compose an Email
              </div>
              <div
                onClick={() => { setIsComposeEmailModalOpen(false) }}
                className="flex sm:items-center rounded-xl hover:bg-zinc-700 p-1 transition-colors duration-200">
                <IoCloseCircleSharp size={20} />
              </div>
            </div>
            <div className="flex  text-zinc-300 items-center justify-start gap-1 mb-3">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 w-full">
                <FaUsers className="text-zinc-400 w-5 h-5 self-start hidden sm:block sm:self-center" />

                <div className="flex flex-wrap items-center gap-1 text-sm border border-zinc-700 p-2 rounded-lg flex-grow min-h-[40px] w-full">
                  {recepientsEmails.map((email, index) => (
                    <span
                      key={index}
                      className="inline-flex items-center bg-zinc-300 text-gray-600 px-2 py-1 rounded-lg"
                    >
                      {email}
                      <button
                        onClick={() => removeEmail(index)}
                        className="ml-2 text-gray-600 hover:text-red-400"
                      >
                        &times;
                      </button>
                    </span>
                  ))}
                  <input
                    type="text"
                    className="bg-transparent outline-none text-zinc-300 flex-grow min-w-[120px]"
                    placeholder="Enter recipients..."
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                  />
                </div>
                <div className="flex gap-2" >
                  <div
                    onClick={() => setShowCc(!showCc)}
                    className={`flex items-center justify-center text-sm border border-zinc-700 py-1 px-2 rounded-lg min-h-[40px] hover:bg-zinc-700 transition-colors duration-200
      ${showCc ? "bg-zinc-700" : "bg-zinc-800"}
      w-full sm:w-auto text-center
    `}
                  >
                    Cc
                  </div>

                  <div
                    onClick={() => setShowBcc(!showBcc)}
                    className={`flex items-center justify-center text-sm border border-zinc-700 py-1 px-2 rounded-lg min-h-[40px] hover:bg-zinc-700 transition-colors duration-200
      ${showBcc ? "bg-zinc-700" : "bg-zinc-800"}
      w-full sm:w-auto text-center
    `}
                  >
                    Bcc
                  </div>
                </div>
              </div>
            </div>

            {showCc && (
              <div className="flex  text-zinc-300 items-center justify-start gap-1 mb-3">
                <div className="flex items-center justify-between sm:space-x-2 w-full">
                  <MdOutlineContentCopy className="text-zinc-400 w-5 h-5 hidden sm:block" />
                  <div className="flex flex-wrap items-center gap-1 text-sm border  border-zinc-700 p-1 rounded-lg flex-grow min-h-[40px]">
                    {ccs.map((email, index) => (
                      <span key={index} className="inline-flex items-center bg-zinc-300 text-gray-600 px-2 py-1 rounded-lg">
                        {email}
                        <button onClick={() => { setCcs(ccs.filter((_, i) => i !== index)) }} className="ml-2 text-gray-600 hover:text-red-400">&times;</button>
                      </span>
                    ))}
                    <input
                      type="text"
                      className="bg-transparent text-zinc-300 outline-none flex-grow  ml-1 min-w-[100px]"
                      placeholder="Cc..."
                      value={inputCcValue}
                      onChange={(e) => setInputCcValue(e.target.value)}
                      onKeyDown={handleCcKeyDown}
                    />
                  </div>
                </div>
              </div>
            )}
            {showBcc && (

              <div className="flex  text-zinc-300 items-center justify-start gap-1 mb-3">
                <div className="flex items-center justify-between sm:space-x-2 w-full">
                  <FiEyeOff className="text-zinc-400 w-5 h-5 hidden sm:block" />
                  <div className="flex flex-wrap items-center gap-1 text-sm border  border-zinc-700 p-1 rounded-lg flex-grow min-h-[40px]">
                    {bccs.map((email, index) => (
                      <span key={index} className="inline-flex items-center bg-zinc-300 text-gray-600 px-2 py-1 rounded-lg">
                        {email}
                        <button onClick={() => { setBccs(bccs.filter((_, i) => i !== index)) }} className="ml-2 text-gray-600 hover:text-red-400">&times;</button>
                      </span>
                    ))}
                    <input
                      type="text"
                      className="bg-transparent outline-none flex-grow text-zinc-300 ml-1 min-w-[100px]"
                      placeholder="bcc..."
                      value={inputBccValue}
                      onChange={(e) => setInputBccValue(e.target.value)}
                      onKeyDown={handleBccKeyDown}
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="flex  text-zinc-300 items-center justify-start gap-1 mb-3">
              <div className="flex items-center justify-between sm:space-x-2 w-full">
                <MdSubject className="text-zinc-400 w-5 h-5 hidden sm:block" />
                <div className="flex flex-wrap items-center gap-1 text-sm border  border-zinc-700 p-1 rounded-lg flex-grow min-h-[40px]">

                  <input
                    type="text"
                    className="bg-transparent outline-none flex-grow text-zinc-300 ml-1 min-w-[100px]"
                    placeholder="Subject..."
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}

                  />
                </div>
              </div>
            </div>

            <ReactQuill
              value={messageBody}
              onChange={setMessageBody}
              modules={modules}
              formats={formats}
              className="w-full  text-zinc-300 text-md"
              theme="snow"
            />

            {attachments && attachments.length > 0 && (
              <div className="flex mt-2 flex-wrap items-center gap-2  p-1 flex-grow">
                {attachments.map((file, index) => (
                  <AttachmentItem key={index} file={file} onRemove={handleRemove} />
                ))}
              </div>
            )}

            <div className="flex flex-col justify-between items-center mt-3 text-zinc-300">


              <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-between sm:space-x-2 w-full space-y-2 sm:space-y-0">
                <input
                  type="text"
                  name="custom prompt"
                  value={customPrompt}
                  placeholder="Add prompt for AI-generated email draft..."
                  onChange={(e) => setCustomPrompt(e.target.value)}
                  className="w-full p-2 border border-zinc-700 bg-zinc-800 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-zinc-300"
                />
                <button
                  onClick={handleDraftEmail}
                  disabled={customPromptLoading}
                  className="w-full sm:w-auto px-4 py-2 bg-zinc-700 text-white border text-sm border-zinc-600 rounded-md hover:border-zinc-700 hover:bg-zinc-800 transition flex items-center justify-center space-x-2"
                >
                  <img src="/assets/logo.png" alt="Logo" className="h-5 w-5" />
                  {customPromptLoading ? (
                    <span>Generating...</span>
                  ) : (
                    <span>Generate</span>
                  )}
                </button>
              </div>

              <div className="flex items-center justify-between w-full p-2 pl-0 pr-0 gap-2 sm:gap-0 space-x-3">
                <div className="flex items-center space-x-3">
                  {/* Send Button */}
                  <button
                    onClick={handleSendEmail} disabled={loading}
                    className="flex items-center justify-between bg-zinc-700 text-zinc-100 font-medium rounded-full px-2 hover:bg-zinc-600 transition-colors">
                    <div className="py-1 pl-2 pr-4 border-r-[1px] border-zinc-600">
                      {loading ? "Sending..." : "Send"}
                    </div>
                    <div className="h-full pl-1 items-center justify-center flex">
                      <MdOutlineArrowDropDown size={20} />
                    </div>
                  </button>

                  {/* Toolbar Icons */}
                  <div className="flex">

                    <div
                      onClick={handlePaperClipClick}
                      className="text-zinc-400 hover:text-zinc-200 w-8 h-8 flex items-center justify-center rounded-md hover:bg-zinc-700 transition-colors">
                      <BsPaperclip size={18} />

                      <input
                        type="file"
                        ref={fileInputRef}
                        className="hidden"
                        onChange={handleFileChange}
                        multiple
                      />
                    </div>
                    {!isOutlook && (
                      <div
                        onClick={handleOpenPicker}
                        className="text-zinc-400 hover:text-zinc-200 w-8 h-8 flex items-center justify-center rounded-md hover:bg-zinc-700 transition-colors">
                        <LiaGoogleDrive size={18} />
                      </div>
                    )
                    }

                    <div className="text-zinc-400 hover:text-zinc-200 w-8 h-8 flex items-center justify-center rounded-md hover:bg-zinc-700 transition-colors">
                      <BsThreeDotsVertical size={18} />
                    </div>
                  </div>
                </div>

                {/* Trash Icon on the Right */}
                <div className="w-auto ml-auto">
                  <button
                    onClick={handleTrashClick}
                    className="text-zinc-400 hover:text-zinc-200 transition-colors">
                    <FaRegTrashAlt size={18} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComposeEmail;